// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__lffIt","header":"PatientQuestionnaire_header__qRUko","info":"PatientQuestionnaire_info__1rDWH"};